import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainPoints() {
  const points = ['Buscás una palabra en medio de una conversación importante y no aparece. Sabés que la sabés. Está ahí. Pero no sale. Y mientras la buscás, la reunión siguió sin vos. La oportunidad pasó. La imagen que proyectaste no fue la que querías proyectar.', 'Tu velocidad de decisión bajó un cambio. Lo notás vos. Lo notan los que te rodean. Tardás más en resolver lo que antes era automático. En un mundo donde los negocios se cierran en segundos y las oportunidades no esperan, eso tiene un costo real y medible.', 'El foco se fragmentó. Empezás una tarea y a los 10 minutos estás en otra. Llegás al final del día con la sensación de haber estado ocupado todo el tiempo pero sin haber terminado nada de lo que realmente importaba.', 'La neblina mental del mediodía se volvió permanente. Antes era el bajón de después del almuerzo. Ahora es la mitad del día que funciona a media máquina sin que haya una razón clara.', 'Empezás a depender de herramientas externas para funciones que antes hacías solo. El GPS para ir a lugares que conocés. La calculadora para cuentas simples. Las notas del celular para recordar lo que hace 10 años memorizabas sin esfuerzo.'];
  return <section className="py-20 px-4 bg-dark-card/30 border-y border-dark-border pt-[15px] pb-[15px]" data-id="element-200">
      <div className="max-w-3xl mx-auto space-y-[16px]" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-202">
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-203">
            ¿Cuántos años más vas a ignorar lo que tu cerebro te está diciendo?
          </h2>
          <p className="text-base text-gray-400" data-id="element-204">
            Si tenés más de 50 años y estás leyendo esto, algo te trajo hasta
            acá.
          </p>
          <p className="text-base text-gray-400 mt-2" data-id="element-205">
            No es casualidad. No es hipocondría. No es vejez inevitable.
          </p>
          <p className="text-xl font-bold text-brand mt-[24px] mb-[-30px]" data-id="element-206">
            Es una señal que tu cerebro te está mandando y que la mayoría de los
            hombres elige ignorar hasta que ya es tarde.
          </p>
          <p className="text-base text-gray-400 mt-12" data-id="element-207">
            Y mientras seguís ignorándola, esto sigue pasando semana tras
            semana:
          </p>
        </motion.div>

        <div className="space-y-2 mb-12" data-id="element-208">
          {points.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-center space-x-3 bg-dark-card border border-dark-border px-3 py-2 rounded-lg" data-id="element-209">
              <div className="bg-red-500/20 p-0.5 rounded-full shrink-0" data-id="element-210">
                <X className="w-4 h-4 text-red-500" data-id="element-211" />
              </div>
              <p className="text-gray-300 text-base" data-id="element-212">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto text-base leading-relaxed space-y-4" data-id="element-213">
          <p className="text-gray-400" data-id="element-214">
            Ninguna de estas cosas es irreversible. El cerebro no es un músculo
            que se atrofia sin remedio después de los 50. Es un sistema que
            responde al entrenamiento a cualquier edad, con la misma lógica que
            el cuerpo responde al ejercicio físico. El problema es que nadie te
            enseñó a entrenarlo de forma sistemática, práctica y adaptada a la
            vida real de un hombre de tu edad y tu nivel de exigencia.
          </p>
          <p className="text-brand font-bold" data-id="element-215">
            Ese es exactamente el agujero que el Protocolo Mente Indomable™
            cierra.
          </p>
        </motion.div>
      </div>
    </section>;
}